module.exports = __webpack_public_path__ + "img/html-css-js-logo.292a66ff.png";